module.exports = __webpack_public_path__ + "static/elwafaapp1-22feebf161e440a1b11bde1e1f485557.jpg";